import script from "./Account.vue?vue&type=script&setup=true&lang=js"
export * from "./Account.vue?vue&type=script&setup=true&lang=js"

import "./Account.vue?vue&type=style&index=0&id=6bcc3a68&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bcc3a68"]])

export default __exports__